import { render, staticRenderFns } from "./OrganizerData.vue?vue&type=template&id=ec5747a2&scoped=true"
import script from "./OrganizerData.vue?vue&type=script&lang=js"
export * from "./OrganizerData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec5747a2",
  null
  
)

export default component.exports